module.exports = __webpack_public_path__ + "static/media/hub_operator_bulk_upload_template.e0a3b9aa.csv";